import { combineReducers } from 'redux';

import native from './native';
import search from './search';
import layout from './layout';
import buttonpay from './buttonpay';

import downloadTask from './downloadTask';
import WelcomApp from './welcomePopUp';
import recommend from './recommend';
import topn from './topn';
import category from './category';
import detail from './detail';
import network from './network';
import log from './log';

// 5.2新增
import acategory from './acategory';
import adetail from './adetail';
import arecommend from './arecommend';
import asimstatus from './asimstatus';

// 5.3新增
import comment from './comment';
import user from './user';

// 5.5新增
import special from './special';
// 6.0新增 壁纸
import wallpaper from './wallpaper';
// 6.1 新增 我的软件
import uninstall from './uninstall';
// 6.5 用户引导
import welcome from './welcome';
// 游戏页
import game from './game';
// 用户反馈
import userFeedback from './userFeedback';
// 卡片的请求
import card from './card';

// v7.0教育频道
import education from './education';
// v7.2
import collection from './collection';
// v7.2 论坛
import forum from './forum';

// v7.4 消息
import message from './message';

// v8.2 订单
import order from './order';
// v8.2 探索
// import discover from './discover';
// v8.3 大搜索
import searchResult from './searchResult';

// v8.5 壁纸我的
import wallpaperPay from './wallpaperPay';


// v9.0.10
import aigc from './aigc';
// 9.0.11
import discount from './discount';
// 9.0.11 游戏CDK购买
import gamecdk from './gamecdk';

export default combineReducers({
  native,
  search,
  layout,
  buttonpay,
  downloadTask,
  recommend,
  topn,
  category,
  WelcomApp,
  detail,
  network,
  log,
  asimstatus,
  arecommend,
  acategory,
  adetail,
  comment,
  user,
  special,
  wallpaper,
  uninstall,
  welcome,
  game,
  userFeedback,
  card,
  education,
  collection,
  forum,
  message,
  order,
  // discover,
  searchResult,
  wallpaperPay,
  aigc,
  discount,
  gamecdk,
});
